import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import React from "react";
import FavouriteButton from "src/storefront/components/favourite_button";

export default class extends Controller {
  connect() {
    const root = createRoot(this.element);
    root.render(React.createElement(FavouriteButton, {
      isFavourite: false,
      onFavouriteChange: (isFavourite: boolean) => { return this.delay(1000, isFavourite); },
    }));
  }

  delay(ms: number, value: boolean) {
    return new Promise<boolean>((resolve) => {
      setTimeout(() => {
        resolve(value);
      }, ms);
    });
  }
}
